module.exports = __webpack_public_path__ + "img/pause-circle.f597dc09.svg";